// --------
module.exports = function (THREE) {
  var CarPaintMaterial = function(parameters) {
    THREE.ShaderMaterial.call(this);

    this.uniforms = THREE.UniformsUtils.clone(window.eqc.carpaint.shader.uniforms);

    this.vertexShader = window.eqc.carpaint.shader.vertexShader;
    this.fragmentShader = window.eqc.carpaint.shader.fragmentShader;

    this.defines = {'PHYSICAL': ''};

    // standard

    this.color = new THREE.Color(0xffffff); // diffuse
    this.roughness = 0.5;
    this.metalness = 0.5;

    this.lights = true;

    this.map = null;

    this.lightMap = null;
    this.lightMapIntensity = 1.0;

    this.aoMap = null;
    this.aoMapIntensity = 1.0;

    this.emissive = new THREE.Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;

    this.bumpMap = null;
    this.bumpScale = 1;

    this.normalMap = null;
    this.normalScale = new THREE.Vector2(1, 1);

    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;

    this.roughnessMap = null;

    this.metalnessMap = null;

    this.alphaMap = null;

    this.envMap = null;
    this.envMapIntensity = 1.0;

    this.refractionRatio = 0.98;

    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';

    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;


    // physical

    this.reflectivity = 0.5; // maps to F0 = 0.04

    this.clearCoat = 0.0;
    this.clearCoatRoughness = 0.0;


    this.setValues(parameters);

  };

  CarPaintMaterial.prototype = Object.assign(Object.create(THREE.ShaderMaterial.prototype), {
    constructor: CarPaintMaterial,
    isMeshStandardMaterial: true,
    isMeshPhysicalMaterial: true
  });

  return CarPaintMaterial;
}


//////////////////
// WEBPACK FOOTER
// ./static/static-assets/eqc/three/CarPaintMaterial.js
// module id = OgCR
// module chunks = 0